exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile {\n  display: block;\n  width: 100%;\n  height: 190px;\n  background-size: cover;\n  z-index: 0;\n  text-align: center; }\n\n.userName {\n  color: #FFFFFF;\n  font-weight: bold;\n  font-size: 14px;\n  z-index: 100; }\n\n.big-avatar {\n  display: block;\n  width: 130px;\n  height: 130px;\n  border-radius: 65px;\n  margin: 0px auto;\n  border-color: #FFFFFF;\n  overflow: hidden;\n  margin-top: 30px;\n  background-color: #FFFFFF; }\n\n.big-avatar img {\n  width: 130px;\n  height: 130px; }\n\n.small-avatar {\n  display: block;\n  width: 50px;\n  height: 50px;\n  border-radius: 30px;\n  margin: 0px auto;\n  border-color: #FFFFFF;\n  overflow: hidden;\n  margin-top: 30px;\n  background-color: #FFFFFF; }\n\n.small-avatar img {\n  width: 50px;\n  height: 50px; }\n\n.role {\n  font-size: 12px;\n  text-transform: uppercase;\n  color: #FFF;\n  font-weight: bold; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/srd-poliflex-pipeline/src/app/components/app-sidebar-header/app-sidebar-header.component.scss
// module id = ../../../../../src/app/components/app-sidebar-header/app-sidebar-header.component.scss
// module chunks = main